import clsx from 'clsx';

/**
 * Utility function to merge class names
 * Combines clsx for conditional classes
 *
 * @param {...any} inputs - Class names or conditional class objects
 * @returns {string} Merged class names
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-primary')
 * cn({ 'text-white': isDark, 'text-black': !isDark })
 */
export function cn(...inputs) {
  return clsx(inputs);
}
